import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import { CLAIM_UPDATES } from 'constants'

import EditNotification from './EditNotification'

import { statusChanged } from 'components/RequestStatus/actions'

import { notificationFetched } from 'scenes/VehicleDetail/components/Claim/Notifications/actions'

export class Notification extends BaseComponent {

  constructor() {
    super()

    this._bind('_showModal', '_sendNotification')
  }

  _showModal() {
    this.context.toggleModal(true,
      <EditNotification notification={this.props.notification} claimId={this.props.claimId} sms_enabled={this.props.sms_enabled}/>
    )
  }

  _sendNotification() {
    const notification = this.props.notification
    this.props.updateRequestStatus('progress', 'Creando notificación...')
    request(CLAIM_UPDATES(this.props.claimId), {
      method: 'POST',
      body: {
        title: notification.title,
        content: notification.content
      }
    }).then((res) => {
      this.props.updateRequestStatus(res.status, res.message)
      this.props.notificationFetched([res.update, ...this.props.notification_list])
    }).catch((err) => {
      this.props.updateRequestStatus('error', 'No pudimos crear la notificación')
    })

    this.context.toggleModal(false)
  }

  render() {
    const notification = this.props.notification
    return (
      <div className="SuggestedNotification d-flex flex-column">
        <p className="SuggestedNotification__title">{notification.title}</p>
        <p className="SuggestedNotification__content">{notification.content}</p>
        <div className="d-flex flex-row">
          {/* <button type="button" className="btn btn-outline-primary" onClick={this._sendNotification}>Enviar</button> */}
          <button type="button" className="btn success btn-outline-primary" onClick={this._showModal}>Crear</button>
        </div>
      </div>
    )
  }
}

Notification.contextTypes = {
  toggleModal: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => {
  return {
    notification_list: state.claimNotification.get('notification_list')
  }
}

const mapDispatchToProps = (dispatch) => {

  return {
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message)),
    notificationFetched: (notification_list) => dispatch(notificationFetched(notification_list))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Notification)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Claim/Suggested/Notification.js